import styled from 'styled-components';

import { ExclamationCircleOutlined } from '@ant-design/icons';

import { NorlysColor, NorlysFont } from '~src/branding';
import { Anchor } from '~src/components/Anchor';
import { ButtonNorlys } from '~src/components/Button';
import { Heading, Text } from '~src/components/Typography';
import { NORLYS_BOOK_URL } from '~src/constants';
import { useDisplayContext } from '~src/context/DisplayContext';
import { usePublicCalculatorContext } from '~src/context/PublicCalculatorContext';

import { TakeoverProps } from './types';
import { getTakeoverInfo } from './util';

const CompactWrapper = styled.div({
  display: 'flex',
  flexFlow: 'row nowrap',
  alignItems: 'center',
  gap: '8px',
});

export const TakeoverNorlys = ({ takeover, residence }: TakeoverProps) => {
  const { isMobile } = useDisplayContext();
  const { heading, text, subtext, button } = getTakeoverInfo(
    takeover,
    residence?.primaryHeating?.fuelType ?? '',
    isMobile,
    'norlys'
  );
  const { setOpenStageMap, setStage, setHeaderExpanded } = usePublicCalculatorContext();

  const updateDesktopStage = () => setOpenStageMap?.({ [button.stage]: true });
  const updateMobileStage = () => {
    setStage(button.stage);
    setHeaderExpanded(false);
  };

  return (
    <div style={{ padding: '16px 0' }}>
      <ExclamationCircleOutlined style={{ color: NorlysColor.primary.acid, fontSize: 32 }} />

      <Heading style={{ padding: '16px 0', ...NorlysFont.style('heading', 22) }}>{heading}</Heading>

      <Text level={2} style={{ lineHeight: 2, ...NorlysFont.style('default', 14) }}>
        {text}
      </Text>

      <Text level={2} style={{ lineHeight: 2, marginTop: '16px', ...NorlysFont.style('default', 14) }}>
        {subtext}
      </Text>

      <div style={{ display: 'flex', justifyContent: 'center', gap: '16px', marginTop: '24px' }}>
        <ButtonNorlys style={{ margin: 0 }} onClick={isMobile ? updateMobileStage : updateDesktopStage}>
          {button.text}
        </ButtonNorlys>

        <Anchor newTab href={NORLYS_BOOK_URL}>
          <ButtonNorlys style={{ margin: 0 }} onClick={() => false}>
            Book tid til rådgiver
          </ButtonNorlys>
        </Anchor>
      </div>
    </div>
  );
};

export const CompactTakeoverNorlys = ({ takeover, residence }: TakeoverProps) => {
  const { heading } = getTakeoverInfo(takeover, residence?.primaryHeating?.fuelType ?? '', true, 'norlys');
  return (
    <CompactWrapper>
      <ExclamationCircleOutlined style={{ color: NorlysColor.primary.acid, fontSize: 32 }} />

      <Heading style={{ padding: '16px 0', ...NorlysFont.style('heading', 22) }}>{heading}</Heading>
    </CompactWrapper>
  );
};
